import React from "react";
import { useTranslation } from "react-i18next";

import classes from "./SidePageWrapper.module.scss";

export interface SidePageWrapperProps {
  small?: boolean;
  hideDisclaimeIcon?: boolean;
  hideDisclaime?: boolean;
  disclaimerText?: string;
  bannerHeading?: string;
  bannerParas?: string[];
  hideBannerWidget?: boolean;
  children?: React.ReactNode;
}

export const SidePageWrapper: React.FC<SidePageWrapperProps> = ({
  children,
  ...props
}) => {
  const { t } = useTranslation(["app"]);
  let wrapperClass = [classes.Wrapper];
  if (props.small) wrapperClass = [...wrapperClass, classes.Small];

  let containerClass = [classes.Wrapper_right_container];
  if (props.small)
    containerClass = [
      ...containerClass,
      classes.Wrapper_right_container_center,
    ];

  const renderParas = (paras: string[]) => {
    return paras.map((single: string, i) => {
      return <p key={i}>{single}</p>;
    });
  };

  return (
    <article className={wrapperClass.join(" ")}>
      <aside className={classes.Wrapper_left}>
        {props.hideBannerWidget ? null : (
          <div role="document" className={classes.Wrapper_left_message}>
            <h2>
              {props.bannerHeading
                ? props.bannerHeading
                : t("app:side_banner_heading")}
            </h2>
            {props.bannerParas ? (
              renderParas(props.bannerParas)
            ) : (
              <>
                <p>{t("app:side_banner_para1")}</p>
                <p>{t("app:side_banner_para2")}</p>
              </>
            )}
          </div>
        )}
      </aside>
      <section className={classes.Wrapper_right}>
        <div className={containerClass.join(" ")}>
          <div className={classes.Container}>{children}</div>
        </div>
        {props.hideDisclaime ? null : (
          <div className={classes.Wrapper_right_disclaimer}>
            <div className={classes.Wrapper_right_disclaimer_icon}>
              {props.hideDisclaimeIcon ? null : <ft-icon>lock</ft-icon>}
            </div>

            <div className={classes.Wrapper_right_disclaimer_text}>
              <p>
                {props.disclaimerText
                  ? props.disclaimerText
                  : t("app:common:privacy")}
              </p>
            </div>
          </div>
        )}
      </section>
    </article>
  );
};
